/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Type_Business_TripInputs */

const vi_work_activity_type_business_trip = /** @type {(inputs: Work_Activity_Type_Business_TripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch công tác`)
};

/**

* @param {Work_Activity_Type_Business_TripInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_type_business_trip = /** @type {((inputs?: Work_Activity_Type_Business_TripInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Type_Business_TripInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_type_business_trip(inputs)
});